exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-border[data-v-45cf2d70]{border:1px solid;border-color:#ccc;margin-bottom:0!important;padding:1.5rem}.radio-up[data-v-45cf2d70]{border-radius:.5rem .5rem 0 0}.radio-down[data-v-45cf2d70]{border-radius:0 0 .5rem .5rem}.radio-selected[data-v-45cf2d70]{background-color:#faeced;border-color:#f44336}", ""]);

// exports
